(function () {
  "use strict";

  angular
    .module("alk.maps")
    .directive("avoidFavorsMap", avoidFavorsMap);

  avoidFavorsMap.$inject = [];

  function avoidFavorsMap() {

    var directive = {
      bindToController: true,
      controller: avoidFavorsMapController,
      controllerAs: "vm",
      template: require("./avoidFavorsMap.html"),
      restrict: "E",
      scope: {}
    };
    return directive;

  }

  avoidFavorsMapController.$inject = ["$window","$scope", "$element", "$attrs", "$translate", "UserProvider","routeExceptionsLayerService",
    "_", "eventTracker"];

  function avoidFavorsMapController($window, $scope, $element, $attrs, $translate, userProvider, routeExceptionsLayerService, _,
    eventTracker) {
    var vm = this;
    vm.isPremium = isPremium;
    vm.frameAvoidFavorsSet = frameAvoidFavorsSet;
    vm.showAll = showAll;
    vm.hideAll = hideAll;
    vm.isAvoidFavorsLayerVisible = isAvoidFavorsLayerVisible;
    vm.toggleSetOnMap = toggleSetOnMap;
    vm.hasAvoidFavors = hasAvoidFavors;
    vm.isAvoidFavorsSetReady = isAvoidFavorsSetReady;
    vm.sets = [];
    vm.isInit = true;
    vm.getSets = getSets;
    vm.isDropDownShow = false;

    routeExceptionsLayerService.initRouteExceptionsLayerFactory();

    function isPremium () {
      return userProvider.getUser().isPremium();
    }

    function frameAvoidFavorsSet(set) {
      routeExceptionsLayerService.frameRouteExceptions(set);
    }

    function getSets () {
      // we can not get sets data during directive init phase as it's still not ready from userService.
      if (vm.isInit) {
        vm.sets = angular.copy(routeExceptionsLayerService.getAvoidFavorsSets());
        showAll();
        vm.isInit = false;
      }
    }

    function hideAll () {
      _.forEach(vm.sets, set => {
        set.visible = false;
        routeExceptionsLayerService.clearSet(set);
      });
      routeExceptionsLayerService.hideAvoidFavorsLayer();
    }

    function showAll () {
      routeExceptionsLayerService.showAvoidFavorsLayer();
      _.forEach(vm.sets, set => {
        set.visible = true;
        routeExceptionsLayerService.addSet(set);
      });
    }

    function isAvoidFavorsLayerVisible () {
      return routeExceptionsLayerService.isAvoidFavorsLayerVisible();
    }

    function toggleSetOnMap (set) {
      if (set.visible) {
        routeExceptionsLayerService.clearSet(set);
        set.visible = false;
        eventTracker.track("Hide Route Modifiers");
      } else {
        routeExceptionsLayerService.showAvoidFavorsLayer();
        set.visible = true;
        routeExceptionsLayerService.addSet(set);
        eventTracker.track("Show Route Modifiers");
      }
    }

    function hasAvoidFavors () {
      return routeExceptionsLayerService.hasAvoidFavors();
    }

    function isAvoidFavorsSetReady () {
      return routeExceptionsLayerService.isAvoidFavorsSetReady();
    }

  }
})();



// WEBPACK FOOTER //
// ./app/avoidFavors/avoidFavorsMap.directive.js